<script lang="ts">
import { defineComponent } from 'vue';
import { formatNumber, roundNumber } from '@/utils/utils';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'MapFooter',
	props: {
		lon: {
			required: false,
			type: Number,
			default: (): number | null => null,
		},
		lat: {
			required: false,
			type: Number,
			default: (): number | null => null,
		},
		ratio: {
			required: false,
			type: Number,
			default: (): number | null => null,
		},
	},
	computed: {
		lonLatStr(): string {
			const lat = roundNumber({ num: this.lat as number, decimals: 6 });
			const lon = roundNumber({ num: this.lon as number, decimals: 6 });
			return `N: ${lat} E: ${lon}`;
		},
		ratioStr(): string {
			const num = this.ratio as number;
			return num ? `1: ${formatNumber({ num })}` : '';
		},
	},
});
</script>

<template>
	<div class="map-footer">
		<div class="map-footer__info">
			<span> EPSG: 3857 </span>
			<span
				v-if="lonLatStr"
				class="ml-12"
			>
				{{ lonLatStr }}
			</span>

			<span
				v-if="ratioStr"
				class="ml-24"
			>
				{{ ratioStr }}
			</span>
		</div>
		<p class="map-footer__info-text">{{ $t('footer.kosovoBorderLabel') }}</p>
	</div>
</template>

<style scoped lang="scss">
.map-footer {
	@include tools.size(100%, 26px);

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 6px 12px;
	background-color: tokens.$color-white;
	font-size: 12px;
	font-weight: 400;

	&__info-text {
		font-style: italic;
	}
}
</style>
